export const APIURI = {
  AuthLogin: "/public/authentification",
};
